import {Box, HBox} from '@buncha/components/core/view';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {H3Text} from '@buncha/components/core/text';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import PrintedBarcodes from '@buncha/components/core/icon/PrintedBarcodes';
import PrinterIcon from '@buncha/components/core/icon/PrinterIcon';
import PrintingIcon from '@buncha/components/core/icon/PrintingIcon';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

const DriverBarCodeEducationHeader = () => {
  const mortise = useFontTheme('mortise');
  const theme = useColorThemeType('main');
  const {body} = useGetLocale(Modules.aboutShift, HomeScreens.AboutShift) ?? {};
  return (
    <Box>
      <HBox
        style={[
          styles.iconBox,
          {backgroundColor: theme?.background?.blue?.[100]},
        ]}>
        <PrinterIcon width={90} height={77} viewBox="15 6 82 82" />
        <PrintingIcon
          width={97}
          height={77}
          style={styles.middleIcon}
          viewBox="8 1 77 81"
        />
        <PrintedBarcodes width={67} height={77} viewBox="-1 -5 82 100" />
      </HBox>
      <H3Text
        style={[
          styles.headerText,
          {fontFamily: mortise?.[700]?.normal, color: theme?.text?.blue?.[300]},
        ]}>
        {body?.printerProceed}
      </H3Text>
    </Box>
  );
};

export default React.memo(DriverBarCodeEducationHeader);

const styles = StyleSheet.create({
  headerText: {
    textAlign: 'left',
  },
  iconBox: {
    gap: 10,
    padding: 20,
    marginBottom: 10,
  },
  middleIcon: {
    marginLeft: -5,
  },
});
